import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_minus",
  "use": "icon_minus-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_minus\"><path d=\"M12.9375 6.9375C13.2482 6.9375 13.5 7.18934 13.5 7.5C13.5 7.81066 13.2482 8.0625 12.9375 8.0625C6.25626 8.0625 9.11511 8.0625 2.0625 8.0625C1.75184 8.0625 1.5 7.81066 1.5 7.5C1.5 7.18934 1.75184 6.9375 2.0625 6.9375L12.9375 6.9375Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol